import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  id: 1,
  question: 'Cum se calculează comisionul agenției?',
  answer: 'Comisionul standard pentru închiriere este 50% + TVA (21%) din valoarea chiriei lunare. Pentru vânzări, comisionul variază în funcție de valoarea tranzacției și se stabilește prin negociere cu proprietarul.'
}, {
  id: 2,
  question: 'Când pot solicita o derogare de comision?',
  answer: 'Poți solicita o derogare prin grupul de suport individual CLC, specificând link-ul proprietății, motivul cererii și procentul propus. Echipa va analiza cererea și va oferi răspuns în maxim 24h.'
}, {
  id: 3,
  question: 'Cum accesez cursurile Masterclass?',
  answer: 'Toate cursurile Masterclass sunt disponibile în platforma pro.cautlocuinta.ro, secțiunea Training. Vei primi acces automat după finalizarea onboarding-ului.'
}, {
  id: 4,
  question: 'Ce fac dacă un proprietar refuză colaborarea?',
  answer: 'Marchezi statusul ca "Nu colaborează" în listă și treci la următorul lead. Nu insista și nu face apeluri repetate. Fiecare refuz este o oportunitate de a găsi un proprietar mai receptiv.'
}, {
  id: 5,
  question: 'Cum anunț o absență sau concediu?',
  answer: 'Anunți prin grupul individual de suport CLC, specificând perioada de absență și motivul. Este important să comunici din timp pentru a nu afecta alocarea listelor zilnice.'
}, {
  id: 6,
  question: 'Cum iau legătura cu echipa juridică sau fiscală?',
  answer: 'Poți contacta echipa juridică sau fiscală prin grupul individual de suport CLC. Descrie situația clar și vei primi răspuns de la specialiștii din departamentul corespunzător.'
}];
export function FAQAccordion() {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  return;
}